// storeReducer.js — mirror DealCouponz storeReducer shape (stores list + current store)
import * as types from "../types/storeTypes";

const initialState = {
  stores: [],
  store: null,
  storeCoupons: [],
  loading: false,
  error: null,
};

const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_STORES_REQUEST:
    case types.LOAD_STORE_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_STORES_SUCCESS:
      return {
        ...state,
        loading: false,
        stores: action.payload || [],
      };

    case types.LOAD_STORE_PAGE_SUCCESS: {
      const { store, storeCoupons, stores } = action.payload;
      return {
        ...state,
        loading: false,
        store,
        storeCoupons: storeCoupons || [],
        stores: stores || state.stores,
      };
    }

    case types.FETCH_STORES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.LOAD_STORE_PAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        store: null,
        storeCoupons: [],
      };

    default:
      return state;
  }
};

export default storeReducer;
